/*
 * WeekplanCalendar Messages
 *
 * This contains all the text for the WeekplanCalendar component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  missingTeamLead: {
    id: 'app.components.ShiftApplicationRecommendationMessage.missingTeamLead',
    defaultMessage: 'Missing team lead',
  },
  missingBrothers: {
    id: 'app.components.ShiftApplicationRecommendationMessage.missingBrothers',
    defaultMessage:
      'Missing {numberOfMissingBrothers} {numberOfMissingBrothers, plural, one {brother} other {brothers}}',
  },
  missingPublishers: {
    id: 'app.components.ShiftApplicationRecommendationMessage.missingPublishers',
    defaultMessage:
      'Missing {numberOfMissingPublishers} {numberOfMissingPublishers, plural, one {publisher} other {publishers}}',
  },
});
